/**
 * The quote made on the package page travels to the booking page in router
 * state. A refresh drops router state, so a copy is kept for this tab only
 * (sessionStorage): the keys, the quote and a short summary of the package —
 * nothing personal. Storage can be unavailable (private mode, blocked site
 * data): every access is guarded and the page falls back to "pick again".
 */

const KEY = 'fastays.packages.bookContext';

export const savePackageBookContext = (context) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(context));
  } catch (e) {
    // storage unavailable — router state still works
  }
};

export const loadPackageBookContext = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    const ctx = raw ? JSON.parse(raw) : null;
    return ctx?.quote?.nextraQuoteId && ctx?.packageKey ? ctx : null;
  } catch (e) {
    return null;
  }
};

export const clearPackageBookContext = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
};
